module.exports = __webpack_public_path__ + "f29d1084b8ca7d174c1fd66cf9813a3c.glb";